import React from 'react';
import { Table, Dropdown, Badge, Spinner } from 'react-bootstrap';
import { Eye, MoreVertical, ShieldAlert } from 'lucide-react';

const PaymentLogsTable = ({ logs, loading, navigate }) => {
  const getGatewayBadge = (provider) => {
    const cleanProvider = (provider || '').toLowerCase();
    if (cleanProvider.includes('razorpay')) {
      return <span className="d-inline-flex align-items-center gap-1 text-white bg-dark px-2 py-1 rounded border border-secondary small font-monospace">Razorpay <Badge bg="primary" style={{fontSize: '10px'}}>RP</Badge></span>;
    }
    if (cleanProvider.includes('phonepe')) {
      return <span className="d-inline-flex align-items-center gap-1 text-white bg-dark px-2 py-1 rounded border border-secondary small font-monospace">PhonePe <Badge bg="secondary" style={{fontSize: '10px', backgroundColor: '#5f259f'}}>PP</Badge></span>;
    }
    return <span className="admin-payments-text-secondary small">{provider || '-'}</span>;
  };

  return (
    <div className="table-responsive">
      <Table hover align="middle" className="m-0 text-nowrap table-dark table-borderless admin-payments-table">
        <thead className="admin-payments-thead">
          <tr className="admin-payments-thead-tr">
            <th className="px-4 py-3 text-uppercase">#</th>
            <th className="py-3 text-uppercase">Application ID</th>
            <th className="py-3 text-uppercase">User Name</th>
            <th className="py-3 text-uppercase">Email</th>
            <th className="py-3 text-uppercase">Gateway</th>
            <th className="py-3 text-uppercase">Order ID</th>
            <th className="py-3 text-uppercase">Payment ID</th>
            <th className="py-3 text-uppercase">Amount</th>
            <th className="py-3 text-uppercase">Status</th>
            <th className="py-3 text-uppercase">Date & Time</th>
            <th className="px-4 py-3 text-center text-uppercase">Action</th>
          </tr>
        </thead>
        <tbody style={{ fontSize: '0.9rem' }}>
          {loading ? (
            <tr>
              <td colSpan="11" className="text-center p-5 admin-payments-text-secondary">
                <Spinner animation="border" className="me-2" size="sm" /> Loading Transactions...
              </td>
            </tr>
          ) : logs.length > 0 ? (
            logs.map((log, idx) => (
              <tr key={log.id} className="admin-payments-tbody-tr">
                <td className="px-4 admin-payments-text-secondary">{idx + 1}</td>
                <td className="fw-semibold text-white font-monospace">{log.application_id}</td>
                <td className="fw-semibold text-white">{log.user_name}</td>
                <td className="admin-payments-text-secondary">{log.email}</td>
                <td>{getGatewayBadge(log.gateway_provider)}</td>
                <td className="font-monospace admin-payments-text-secondary small">{log.order_id}</td>
                <td className="font-monospace admin-payments-text-secondary small">{log.payment_id}</td>
                <td className="fw-bold text-white">₹{Number(log.amount).toFixed(2)}</td>
                <td>
                  <Badge bg={log.payment_status === 'SUCCESS' || log.payment_status === 'BOOKED' ? 'success' : log.payment_status === 'FAILED' ? 'danger' : 'warning'} className="px-2 py-1 rounded text-uppercase">
                    {log.payment_status}
                  </Badge>
                </td>
                <td className="text-muted">{log.created_at ? new Date(log.created_at).toLocaleString('en-IN') : '-'}</td>
                <td className="px-4 text-center">
                  <div style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "8px", width: "100%", margin: "0 auto" }}>
                    <button
                      type="button"
                      style={{
                        background: "#2563eb",
                        backgroundColor: "#2563eb",
                        color: "#ffffff",
                        border: "none",
                        borderRadius: "6px",
                        width: "32px",
                        height: "32px",
                        display: "inline-flex",
                        alignItems: "center",
                        justifyContent: "center",
                        cursor: "pointer",
                        padding: 0,
                        flexShrink: 0
                      }}
                      onClick={() => navigate(`/admin/payment-logs/${log.id}`)}
                      title="View Transaction Details"
                    >
                      <Eye size={15} color="#ffffff" />
                    </button>

                    <Dropdown align="end">
                      <Dropdown.Toggle as="div" className="no-caret admin-payments-dropdown-toggle">
                        <MoreVertical size={16} className="text-secondary" />
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="dropdown-menu-dark admin-payments-dropdown-menu">
                        <Dropdown.Item onClick={() => navigate(`/admin/payment-logs/${log.id}`)}>View Details</Dropdown.Item>
                        {log.payment_status !== 'SUCCESS' && log.payment_status !== 'BOOKED' && (
                          <Dropdown.Item className="text-danger" onClick={() => navigate(`/admin/payment-logs/${log.id}/approve`)}>
                            Manual Approve
                          </Dropdown.Item>
                        )}
                      </Dropdown.Menu>
                    </Dropdown>
                  </div>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="11" className="text-center p-5 admin-payments-text-secondary">
                <ShieldAlert size={36} className="mb-2" />
                <p className="m-0">No transaction matched search conditions.</p>
              </td>
            </tr>
          )}
        </tbody>
      </Table>
    </div>
  );
};

export default PaymentLogsTable;
